import mixpanel from 'mixpanel-browser';

// Initialise mixpanel on client load
(() => {
  mixpanel.init(
    process.env.MIXPANEL_TOKEN || 'e7430454c8150dc3a93ec545f390c446',
  );
})();
